import axios from 'axios';

let base = sessionStorage.getItem("base_url") || window.location.host;
const chatBaseURL = process.env.REACT_APP_ENV==='production' ? `https://${base}/chat`: process.env.REACT_APP_CHAT_BASE_URL;
const websocketBaseURL = process.env.REACT_APP_ENV==='production' ? `wss://${base}/chat`:process.env.REACT_APP_CHAT_BASE_URL;

const api = axios.create({
    baseURL: process.env.REACT_APP_ENV==='production' ? `https://${base}/api` :  process.env.REACT_APP_API_BASE_URL,
    withCredentials: true
});

// Add a request interceptor to attach token
api.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401)) {
            sessionStorage.removeItem("token"); // Clear token
        }
        return Promise.reject(error);
    }
);
export default api;
export { chatBaseURL, websocketBaseURL };